export default __webpack_public_path__ + "static/media/img3.9bab29f2.png";